import { render, staticRenderFns } from "./RelacaoReaberturaEntregas.vue?vue&type=template&id=82438be4"
import script from "./RelacaoReaberturaEntregas.vue?vue&type=script&lang=js"
export * from "./RelacaoReaberturaEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports